// combatpro/panels/monsters/studio/MonsterStudioSidebar.js
//
// Combat PRO - MonsterStudioSidebar (Stage 54 shell, Stage 57 library runtime).
//
// Stage 54 established this as a static skeleton. Stage 57 (Library Runtime
// Foundation) wires it to the library runtime (useMonsterStudioLibrary, passed in
// as props.library): the section tabs, search field, and filter row are now
// controlled inputs driven by the runtime, and the collections + library list
// mounts render runtime-generated content (MonsterStudioCollections /
// MonsterStudioLibraryList).
//
// Faithful to the master spec (battletracker.html 3334-3356): section order and
// labels (Official / My Monsters / Favourites / Recently Edited / Archived),
// search, and the six filter inputs. The size options are consumed from the Stage
// 55 engine (STUDIO_SIZES) rather than duplicated. The Environment filter input is
// preserved but, per the legacy, is not applied to the list (see the library
// runtime note). No DOM access, no manual HTML. No optional chaining. No em dash.

import React from 'react';
import { STUDIO_SIZES } from '../../../monster/monsterStudioEngine';
import MonsterStudioCollections from './MonsterStudioCollections';
import MonsterStudioLibraryList from './MonsterStudioLibraryList';

var SECTIONS = [
  ['official', 'Official'],
  ['mine', 'My Monsters'],
  ['favourites', 'Favourites'],
  ['recent', 'Recently Edited'],
  ['archived', 'Archived']
];

function MonsterStudioSidebar(props) {
  var lib = props.library;
  var f = lib.filters;

  return (
    <aside className="vi-st-sidebar">
      <div className="vi-st-side-title">Monster Library</div>
      <div className="vi-st-libtabs">
        {SECTIONS.map(function(sec) {
          var cls = 'vi-st-libtab' + (lib.activeSection === sec[0] ? ' is-active' : '');
          return (
            <button key={sec[0]} type="button" className={cls} data-sec={sec[0]} onClick={function() { lib.setSection(sec[0]); }}>
              {sec[1]}
            </button>
          );
        })}
      </div>
      <input
        id="vi-st-search"
        className="vi-st-search"
        type="text"
        placeholder="🔍 Search library…"
        value={lib.searchQuery}
        onChange={function(e) { lib.setSearch(e.target.value); }}
      />
      <div className="vi-st-filters">
        <input id="vi-st-f-type" placeholder="Type" value={f.type} onChange={function(e) { lib.setFilter('type', e.target.value); }} />
        <input id="vi-st-f-cr" placeholder="CR" value={f.cr} onChange={function(e) { lib.setFilter('cr', e.target.value); }} />
        <select id="vi-st-f-size" value={f.size} onChange={function(e) { lib.setFilter('size', e.target.value); }}>
          <option value="">Size</option>
          {STUDIO_SIZES.map(function(sz) { return <option key={sz} value={sz}>{sz}</option>; })}
        </select>
        <input id="vi-st-f-align" placeholder="Alignment" value={f.align} onChange={function(e) { lib.setFilter('align', e.target.value); }} />
        <input id="vi-st-f-env" placeholder="Environment" value={f.env} onChange={function(e) { lib.setFilter('env', e.target.value); }} />
        <input id="vi-st-f-tag" placeholder="Tag" value={f.tag} onChange={function(e) { lib.setFilter('tag', e.target.value); }} />
      </div>
      <MonsterStudioCollections collections={lib.collections} activeCollection={lib.activeCollection} onToggle={lib.toggleCollection} />
      <MonsterStudioLibraryList count={lib.items.count} items={lib.items.shown} capped={lib.items.capped} onPick={lib.load} />
    </aside>
  );
}

export default MonsterStudioSidebar;
